import React from 'react'
import './Portaria.css'
import brasao from '../../assets/brasilNav.png'

const converterDataParaTexto = (data) => {
    const meses = [
        'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
        'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
    ]

    const [ano, mes, dia] = data.split('-')
    return `${dia} de ${meses[parseInt(mes) - 1]} de ${ano}`
}

const CapaProcesso = ({ processo }) => {
    return (
        <div className="portariaContainer">
            <header className="portariaHeader">
                <img src={brasao} alt="Brasil" crossorigin="anonymous"/>
                <p>Serviço Público Federal</p>
                <p>Conselho Regional de Fisioterapia e Terapia Ocupacional da 1ª Região</p>
                <p>CREFITO-1</p>
            </header>

            <section className="portariaContent">
                <p className='portariBold'>PORTARIA Nº {processo.portaria || '___'}, de {processo.dataInstauracao ? converterDataParaTexto(processo.dataInstauracao.slice(0, 10)) : '___'}</p>

                <div className="textoAlinhadoDireita">
                    <p>
                        Instaura procedimento para {processo.motivo || '___'}
                    </p>
                </div>

                <p>
                    O Presidente do Conselho Regional de Fisioterapia e Terapia Ocupacional da 1ª Região - 
                    CREFITO-1, no uso das atribuições legais, conferidas pela Lei nº 6.316/75, e regulamentares, 
                    conferidas pelo Regimento Interno (RESOLUÇÃO Nº 04, de 09 de março de 2024);
                </p>

                {/* Iteração sobre os Considerandos */}
                {processo.considerandoQue && processo.considerandoQue.length > 0 ? (
                    processo.considerandoQue.map((considerando, index) => (
                        <p key={index}>
                            CONSIDERANDO {considerando || '___'}
                        </p>
                    ))
                ) : (
                    <p>CONSIDERANDO ___</p>
                )}

                <p>RESOLVE:</p>

                <p>Artigo 1º- Determinar a instauração de procedimento administrativo para análise, tomada de decisão e providências quanto ao assunto em tela.</p>
                <p>Artigo 2º- Esta portaria entra em vigor na data de sua assinatura.</p>

                <p className="portariaFooter">
                    Recife/PE, {processo.dataInstauracao ? converterDataParaTexto(processo.dataInstauracao.slice(0, 10)) : '___'}.
                </p>
            </section>

            <div className="assinaturaContainer">
                <div className="assinatura">
                    <p>FLÁVIO MACIEL DIAS DE ANDRADE</p>
                </div>
                <p>Presidente</p>

                <div className="sedeFooter">
                    SEDE: Rua Henrique Dias, 303 | Boa Vista | CEP: 50.070-140 | Recife/PE.<br />
                    site: www.crefito1.org.br | e-mail: crefito1@crefito1.org.br
                </div>
            </div>
        </div>
    )
}

export default CapaProcesso
